var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pd-20 pd-lg-25 pd-xl-30"},[_c('h3',{staticClass:"tx-16 tx-sm-20 tx-md-24 mg-b-15 mg-md-b-20"},[_vm._v(_vm._s(_vm.task.task))]),_c('p',{staticClass:"tx-14 tx-md-16 tx-color-02",domProps:{"innerHTML":_vm._s(_vm.task.taskDesc)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }